import React from 'react';

import { Box } from '@mui/material';

import styles from './flowConnector.module.css';

const FlowConnector = () => (
    <Box className={styles.connector} aria-hidden="true">
        <svg className={styles.arrow} viewBox="0 0 34 12">
            <path d="M1 6 H30 M25 1.5 L30.5 6 L25 10.5" />
        </svg>
    </Box>
);

export default FlowConnector;
